module.exports = __webpack_public_path__ + "img/ai-weapon6.e0dd1385.png";